export const text = {
  Application: "Application",
  Employees: "Employees",
  "My Team List": "My Team List",
  "My Team": "My Team",
  "Team Todo": "Team Todo",
  "My Opinion": "My Opinion",
  "Web Form": "Web Form",
  "My Development": "My Development",
  "My Development Goal": "My Development Goal",
  "Assign Goal To Team": "Assign Goal To Team",
  "My Development Blog": "My Development Blog",
  Onboarding: "Onboarding",
  "Onboarding Task": "Onboarding Task",
  "Onboarding Quiz": "Onboarding Quiz",
  "Onboarding Template": "Onboarding Template",
  Academy: "Academy",
  Category: "Category",
  Course: "Course",
  Lesson: "Lesson",
  Chapter: "Chapter",
  Box: "Box",
  "Asset Category": "Asset Category",
  Asset: "Asset",
  "Book Asset": "Book Asset",
  News: "News",
  Agenda: "Agenda",
  "Event Type": "Event Type",
  "Calender Event": "Calender Event",
  Keys: "Keys",
  "Key Folder": "Key Folder",
  Settings: "Settings",
  Report: "Report",
  "Form List": "Form List",
  Article: "Article",
  "Read Form": "Read Form",
  Logout: "Logout",
  SwitchLanguage: "Switch Language",
  "Form Builder": "My Opinion Form ",
  "Add Leave Type": "Leave Type",
  "Add Leave Allowcation": "Leave Allocation",
  Hr: "HR",
  "Leave Settings": "Leave Settings",
  "Add Leave Policy": "Add Leave Policy",
  "Add Holiday": "Add Holiday",
  "New Leave Request": "Leave Request",
  "Leave Block List": "Leave Block List",
  "New Leave Request": "New Leave Request",
};
